export enum UserMenuTypes {
  WHCUsers,
  PartnerUsers,
}
